import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { BooklistProjectListPage } from '@/features/productRequisition/pages/BooklistProjectListPage';
import { studentProjectSearchSchema } from '@/features/productRequisition/types/productRequisition.types';

export const Route = createFileRoute('/_auth/product/booklisted-institution/')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.BOOKLISTED_INSTITUTE_VIEW),
  validateSearch: studentProjectSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Booklisted Institution">
      <Suspense fallback={<PageLoader />}>
        <BooklistProjectListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
